<template>
  <Head title="Avid - Email Verification" />
  
  <div class="container min-vw-100 mx-0 px-0">
    <div class="row justify-content-center min-vh-100 onboarding-new">
        <div class="col-6 d-none d-lg-block bg-with-image">
            <div class="container-fluid mt-3 ms-4">
                <Link class="navbar-brand" href="/">
                    <img src="/img/logo_png/avid_logo_red.png" alt="Avid" class="logo">
                </Link>
            </div>
        </div>
        <div class="col-lg-6 col-12 d-flex align-items-center justify-content-center">
            <div class="registration-form-container mx-4 mt-md-3 mt-0">
                <div class="navbar-brand d-lg-none col-12 d-flex align-items-center justify-content-center mb-5">
                    <img src="/img/logo_png/avid_logo_red.png" alt="Avid" class="logo">
                </div>
                <h2 class="text-center">Verify Your Email</h2>
                <div class="row">
                    <div v-if="resent" class="alert alert-success" role="alert">
                        A fresh verification link has been sent to your email address.
                    </div>

                    <p>Before proceeding, please check your email for a verification link.</p>
                    <p>If you did not receive the email,</p>
                    <form class="d-inline" method="POST" action="/email/verification-notification" @submit.prevent="resend">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <button type="submit" class="btn btn-link p-0 m-0 align-baseline">click here to request another</button>.
                    </form>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
  resent: {
    type: Boolean,
    default: false
  }
});

const csrfToken = computed(() => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'));

const resend = () => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/email/verification-notification';
  
  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = '_token';
  tokenInput.value = csrfToken.value;
  form.appendChild(tokenInput);
  
  document.body.appendChild(form);
  form.submit();
};
</script>

